/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HorseSearchResultDto
 */
export interface HorseSearchResultDto {
    /**
     * 
     * @type {string}
     * @memberof HorseSearchResultDto
     */
    registerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HorseSearchResultDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HorseSearchResultDto
     */
    breed?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof HorseSearchResultDto
     */
    birthday?: Date | null;
}

/**
 * Check if a given object implements the HorseSearchResultDto interface.
 */
export function instanceOfHorseSearchResultDto(value: object): value is HorseSearchResultDto {
    return true;
}

export function HorseSearchResultDtoFromJSON(json: any): HorseSearchResultDto {
    return HorseSearchResultDtoFromJSONTyped(json, false);
}

export function HorseSearchResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): HorseSearchResultDto {
    if (json == null) {
        return json;
    }
    return {
        
        'registerId': json['registerId'] == null ? undefined : json['registerId'],
        'name': json['name'] == null ? undefined : json['name'],
        'breed': json['breed'] == null ? undefined : json['breed'],
        'birthday': json['birthday'] == null ? undefined : (new Date(json['birthday'])),
    };
}

export function HorseSearchResultDtoToJSON(json: any): HorseSearchResultDto {
    return HorseSearchResultDtoToJSONTyped(json, false);
}

export function HorseSearchResultDtoToJSONTyped(value?: HorseSearchResultDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'registerId': value['registerId'],
        'name': value['name'],
        'breed': value['breed'],
        'birthday': value['birthday'] == null ? undefined : ((value['birthday'] as any).toISOString().substring(0,10)),
    };
}

